import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsOrderRecived = React.forwardRef(
  (props: SvgIconProps, ref: any) => {
    return (
      <SvgIcon {...props} ref={ref}>
        <g fill="currentColor">
          <path
            d="M17.1262569,10.5951462c-3.327693,0-6.0364904,2.7087955-6.0364904,6.0364895s2.7087955,6.0364895,6.0364904,6.0364895
		s6.0364895-2.7087955,6.0364895-6.0364895S20.453949,10.5951462,17.1262569,10.5951462z M17.1262569,21.3496056
		c-2.6011629,0-4.7179689-2.1168079-4.7179689-4.7179699s2.1168079-4.7179699,4.7179689-4.7179699
		c2.603405,0,4.7202129,2.1168079,4.7202129,4.7179699H21.846468C21.846468,19.2327976,19.72966,21.3496056,17.1262569,21.3496056z"
          />
          <path
            d="M4.7640109,19.4839439c0.1659365,0.0246658,0.331872,0.0269089,0.4888387,0.0269089
		c1.8163285,0.002243,3.6640511,0.002243,5.4489851,0.002243h0.2533894l-0.0986643-0.2332096
		c-0.1345425-0.3184185-0.2489052-0.6749554-0.3408422-1.0539188l-0.031394-0.1278152H8.896718
		c-1.2669449,0-2.5787377,0-3.8703485,0.0022411c-0.1479979,0-0.2758136,0.0179386-0.3879328,0.0560608
		c-0.2937512,0.1009064-0.4888387,0.4148388-0.4507179,0.7287731v0.0000019
		C4.2280827,19.1969204,4.4590478,19.4368534,4.7640109,19.4839439z"
          />
          <path
            d="M4.6989813,16.519516h0.0000014c0.1255727,0.0336361,0.2668424,0.0493336,0.4148402,0.0493336
		c0.5605955,0,1.1256742,0,1.6862693,0c0.5650806,0,1.1256757,0,1.679544,0c0.5605955,0,1.1211901,0,1.6840277,0h0.1636934
		l0.0044851-0.1636944c0.0112114-0.3744774,0.0493326-0.7332582,0.1166039-1.0673723l0.0403624-0.1995726h-5.460197
		c-0.2175112,0-0.5314445,0.0358782-0.7242889,0.3520546c-0.1188459,0.1928444-0.1412697,0.4193249-0.0605445,0.6233807
		C4.3222618,16.3132191,4.4859552,16.4589729,4.6989813,16.519516z"
          />
          <path
            d="M11.076313,13.5236959l0.0470905-0.089695c0.1659355-0.3139334,0.3699932-0.6301079,0.6121702-0.939558
		l0.1053915-0.1367846l-0.1390276-0.1031494c-0.089695-0.0672712-0.17939-0.1076336-0.273571-0.1233301
		c-0.1547241-0.029151-0.3139334-0.0358782-0.4484758-0.0381212h-0.002243
		c-0.9799213-0.0022421-1.9755373-0.0022421-2.9375191-0.0022421H5.0622473c-0.5493832,0-0.8790135,0.2646008-0.8790135,0.7085924
		c0,0.4462337,0.334115,0.724288,0.8700433,0.724288c0.6570187,0,1.318521,0,1.9777803,0c0.6615024,0,1.3207626,0,1.9710531,0
		c0.6570177,0,1.3162785,0,1.9732952,0H11.076313z"
          />
          <path
            d="M12.5114365,21.6209354v-0.0000019l-0.0493326-0.0448475H2.2547863c0-1.5651817,0.0022418-3.1303635,0.0022418-4.6977882
		c0-3.1258793,0.002243-6.3571501,0.0044849-9.532362c0-0.2376919,0-0.4798684-0.0022418-0.7130766
		c-0.002243-0.7287741-0.0067267-1.4822135,0.022424-2.2199574c0.0336356-0.8678002,0.802772-1.7535405,1.6773005-1.9396594
		C4.6384368,2.329731,5.3290911,2.4866977,5.8515654,2.90378C6.369555,3.3163786,6.6745195,3.9442453,6.6879735,4.6281714
		C6.6969419,5.1349487,6.6991854,5.6506963,6.701427,6.1485052c0.0022435,0.4170823,0.0022435,0.84762,0.0089703,1.2714305
		c0.0089688,0.6323514,0.2668424,0.8902249,0.8902254,0.8902249c0.0022416,0,0.0067267,0,0.0089688,0
		c1.3207626-0.002243,2.6415243-0.0067263,3.9622869-0.0112114c1.3230047-0.0044851,2.6460094-0.0089703,3.9667721-0.0112123
		h0.0044851v1.7221489l0.2018147-0.0426064c0.3229036-0.0672712,0.6727133-0.1076336,1.0673723-0.1255722L16.973774,9.83498
		V8.3079176h0.5381718c0.7242889,0.002243,1.4485779,0.002243,2.1728668,0.002243c0.7198048,0,1.4418507,0,2.1638985,0.0022421
		c0.0874538,0,0.17939,0,0.271328-0.0089684h0.0022411c0.4439907-0.0538177,0.7085915-0.3408422,0.7085915-0.7691364
		c0-0.2489052,0-0.5022941,0-0.7489557c0-0.8722854,0.002243-1.7759647-0.0515747-2.6639485
		c-0.0829678-1.390276-1.3633671-2.7491581-2.8567924-3.0272141c-0.3139343-0.0583013-0.6211395-0.0874521-0.9126492-0.0874521
		c-0.7399864,0-1.4799728-0.0022432-2.2222004-0.0022432c-3.993679-0.0044851-8.1219025-0.0089687-12.1828537,0.004485
		c-0.7130771,0.0022418-1.3521554,0.1547248-1.899297,0.4596881C2.1449089,1.7781059,1.678494,2.2467639,1.3152281,2.8589337
		C0.9945679,3.4015901,0.839843,4.0473957,0.839843,4.8344707c-0.0044836,5.7606764-0.0022418,11.617775,0,17.2820301
		C0.839843,22.6950359,1.1448077,23,1.7210999,23c1.3543971,0,2.7222495,0,4.0811329,0c1.3678527,0,2.7289762,0,4.0676785,0
		c1.3588829,0,2.7177658,0,4.0744057,0h0.6928968l-0.6166553-0.3184185
		C13.4801455,22.4012833,12.9711246,22.0447445,12.5114365,21.6209354z M11.2153406,2.4216681
		c1.300581,0,2.601162,0.0022433,3.8994999,0.0022433c0.4125986,0,0.8319225,0,1.2377939-0.0022433
		c0.9933739-0.0044849,2.0203857-0.0067267,3.0272141,0.0201821c1.1234322,0.0313923,2.0136585,0.9574969,2.027113,2.1078377
		c0.0067272,0.5964727,0.0067272,1.2019157,0.0044861,1.7894197c0,0.1861176,0,0.3744779,0,0.5605955H8.1141281V6.8234615
		c0-0.2040563,0-0.4103556,0.002243-0.6144118C8.1186132,5.7381501,8.1186132,5.249311,8.111887,4.7694411
		C8.1074018,4.4689627,8.082736,4.1998773,8.0401297,3.9442453C7.94595,3.3993471,7.7149849,2.9082651,7.3270531,2.4194262
		C8.6231489,2.4194262,9.9192448,2.4216681,11.2153406,2.4216681z"
          />
          <polygon
            points="15.9108858,18.0824566 14.3681278,16.519516 13.6617775,17.187746 15.9377947,19.4951572 20.5997028,14.373559 
		19.817112,13.7882986 	"
          />
        </g>
      </SvgIcon>
    );
  }
);

export default AppIconsOrderRecived;
